import { environment } from '../../../../environment';
import { clearCacheData, getCacheVersion } from '../../storage/cache';

export const checkCacheVersion = () => {
  const currentVersion = environment.VERSION;
  const cacheVersion = getCacheVersion();

  if (currentVersion && currentVersion !== cacheVersion) {
    clearCacheData(currentVersion);
  }
};
